import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { route } from "../../../../shim/jsbridge";
import { isBlankOrHangulFiller } from "../../../../utils";

const ExtractedFilesFileNameCell = ({
  id,
  fileName,
  sha1,
  sampleSourceId,
  onClick
}) => {
  // check if filename contains any regular characters, otherwise replace it with hash value
  const displayName =
    !fileName || isBlankOrHangulFiller(fileName) ? sha1 : fileName;
  if (!id) {
    return (
      <a
        className="sample-link no-expand overflow-ellipsis pointer-cursor"
        title={`Browse ${displayName}`}
        onClick={onClick}
      >
        {displayName}
      </a>
    );
  }
  return (
    <Link
      to={route(
        "samples_details_main",
        {
          hash_value: sha1,
          source_id: sampleSourceId
        },
        { r: id }
      )}
      className="sample-link no-expand overflow-ellipsis w-100"
      style={{ minWidth: "40px" }}
      title={`See details for ${displayName}`}
      onClick={onClick}
    >
      {displayName}
    </Link>
  );
};

ExtractedFilesFileNameCell.propTypes = {
  id: PropTypes.number,
  fileName: PropTypes.string,
  sha1: PropTypes.string,
  sampleSourceId: PropTypes.string,
  onClick: PropTypes.func
};

export default ExtractedFilesFileNameCell;
